// src/screens/ResultsScreen.css.js - VERSÃO COMPLETA MELHORADA
import React from 'react';
import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  
  additionalEvaluatorBadge: {
    backgroundColor: '#FF9800',
    color: '#FFFFFF',
    fontSize: 10,
    paddingHorizontal: 8,
    marginLeft: 8,
  },
  container: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 20,
    fontWeight: 'bold',
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 14,
    opacity: 0.9,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: AVAQualisTheme.colors.primary,
  },
  searchBar: {
    margin: 16,
    elevation: 2,
    backgroundColor: '#FFFFFF',
  },
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 16,
    paddingVertical: 8,
    elevation: 2,
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 8,
    borderRadius: 8,
  },
  activeTab: {
    backgroundColor: `${AVAQualisTheme.colors.primary}15`,
  },
  tabText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#666',
    fontWeight: '500',
  },
  activeTabText: {
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  content: {
    flex: 1,
    paddingHorizontal: 16,
  },

  // Card de Formulário
  formCard: {
    marginVertical: 8,
    elevation: 2,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
  },
  formHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  formInfo: {
    flex: 1,
  },
  formTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 4,
  },
  formDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
  editButton: {
    margin: -8,
  },

  // CORRIGIDO: Progresso dos Avaliadores
  evaluatorProgressContainer: {
    marginTop: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    overflow: 'hidden',
  },
  overallProgressSection: {
    padding: 16,
    backgroundColor: '#E3F2FD',
  },
  overallProgressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  overallProgressTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1976D2',
  },
  overallProgressSubtitle: {
    fontSize: 12,
    color: '#64B5F6',
    marginBottom: 8,
  },
  overallProgressBadge: {
    backgroundColor: '#1976D2',
    fontSize: 16,
    fontWeight: 'bold',
  },
  overallProgressBar: {
    height: 12,
    borderRadius: 6,
    backgroundColor: '#BBDEFB',
  },
  progressDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
    marginVertical: 0,
  },
  evaluatorsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    padding: 16,
    paddingBottom: 8,
  },
  evaluatorsContainer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 12,
  },
  evaluatorCard: {
    flex: 1,
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    position: 'relative',
  },
  evaluatorHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  evaluatorName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    flex: 1,
  },
  evaluatorLogin: {
    fontSize: 12,
    color: '#666',
    marginBottom: 8,
  },
  progressInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 8,
  },
  progressPercentage: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  progressQuestions: {
    fontSize: 12,
    color: '#666',
  },
  evaluatorProgressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  statusChip: {
    height: 24,
    backgroundColor: '#E0E0E0',
  },
  statusChipComplete: {
    backgroundColor: '#4CAF50',
  },
  statusChipProgress: {
    backgroundColor: '#FF9800',
  },
  additionalEvaluatorsTitle: {
    fontSize: 12,
    color: '#FF9800',
    fontWeight: '600',
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 4,
  },

  // NOVO: Conformity Summary
  conformitySummaryContainer: {
    marginTop: 16,
    padding: 16,
    backgroundColor: '#F0F7FF',
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#2196F3',
  },
  conformitySummaryTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1976D2',
    marginBottom: 12,
  },
  conformityGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  },
  conformityItem: {
    flex: 1,
    alignItems: 'center',
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E3F2FD',
  },
  conformityValue: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  conformityLabel: {
    fontSize: 12,
    color: '#666',
  },
  conformityPercent: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1976D2',
    marginTop: 4,
  },
  conformityDivider: {
    marginVertical: 12,
    backgroundColor: '#E3F2FD',
  },
  conformitySubtitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FF6F00',
    marginBottom: 8,
  },
  conformityREGrid: {
    flexDirection: 'row',
    gap: 16,
  },
  conformityREItem: {
    flex: 1,
  },
  conformityRELabel: {
    fontSize: 12,
    color: '#666',
    marginBottom: 2,
  },
  conformityREValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },

  // Estatísticas
  statisticsContainer: {
    marginTop: 16,
    padding: 16,
    backgroundColor: '#E8F5E9',
    borderRadius: 8,
  },
  statisticsTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#2E7D32',
    marginBottom: 12,
  },
  statisticsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  statItem: {
    flex: 1,
    minWidth: '45%',
    alignItems: 'center',
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
  },
  statValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
  },
  statLabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },
  statValueHighlight: {
    color: AVAQualisTheme.colors.primary,
  },

  // Botão Expandir
  expandButton: {
    marginTop: 16,
    borderColor: AVAQualisTheme.colors.primary,
  },

  // Lista de Requisitos
  requirementsList: {
    marginTop: 16,
    gap: 8,
  },

  // Card de Resultado
  resultCard: {
    marginVertical: 4,
    elevation: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
  },
  resultHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  resultInfo: {
    flex: 1,
  },
  resultCodeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    gap: 8,
  },
  codeChip: {
    height: 28,
    borderColor: AVAQualisTheme.colors.primary,
  },
  essentialBadge: {
    backgroundColor: '#FFC107',
    fontSize: 12,
    fontWeight: 'bold',
  },
  resultQuestion: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },
  resultStatus: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  finalResultBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  finalResultText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  divider: {
    marginVertical: 12,
  },

  // Tabela de Respostas
  answersTable: {
    marginBottom: 16,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#F5F5F5',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 4,
  },
  tableHeaderText: {
    flex: 1,
    fontSize: 12,
    fontWeight: 'bold',
    color: '#666',
    textAlign: 'center',
  },
  tableHeaderFinal: {
    color: AVAQualisTheme.colors.primary,
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 12,
  },
  tableCell: {
    flex: 1,
    alignItems: 'center',
  },
  tableCellFinal: {
    backgroundColor: '#F8F9FA',
    marginHorizontal: -12,
    paddingHorizontal: 12,
  },
  answerText: {
    fontSize: 14,
    fontWeight: '500',
  },
  answerTextBold: {
    fontWeight: 'bold',
  },
  noResponseText: {
    fontSize: 14,
    color: '#999',
    fontStyle: 'italic',
  },

  // Detalhes do Requisito
  requirementDetails: {
    marginBottom: 16,
    gap: 12,
  },
  detailSection: {
    gap: 4,
  },
  detailLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: '#666',
  },
  detailText: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },

  // Achados
  findingsContainer: {
    padding: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
  },
  findingsTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  evaluatorFinding: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  evaluatorFindingName: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 8,
  },
  findingText: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },
  noFindingText: {
    fontSize: 14,
    color: '#999',
    fontStyle: 'italic',
  },

  // MELHORADO: Anexos com estilos do AttachmentComponent
  attachmentsSection: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  attachmentsTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#666',
    marginBottom: 8,
  },
  
  // Estilo do card de anexo melhorado
  attachmentItemCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    marginBottom: 8,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
    elevation: 1,
  },
  
  attachmentItemIcon: {
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  
  attachmentIconEmoji: {
    fontSize: 24,
  },
  
  attachmentItemContent: {
    flex: 1,
    paddingRight: 8,
  },
  
  attachmentName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  
  attachmentDescription: {
    fontSize: 12,
    color: '#666',
    fontStyle: 'italic',
    lineHeight: 16,
    marginBottom: 2,
  },
  
  attachmentValidity: {
    fontSize: 11,
    color: '#FF9800',
    fontWeight: '600',
    marginTop: 2,
  },
  
  attachmentValidityExpired: {
    color: '#F44336',
  },
  
  attachmentValidityWarning: {
    color: '#FF9800',
  },
  
  attachmentItemAction: {
    padding: 8,
  },

  // NOVO: Subgroup Selector
  subgroupButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    marginHorizontal: 16,
    marginVertical: 8,
    padding: 12,
    borderRadius: 8,
    elevation: 2,
    gap: 8,
  },
  subgroupButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
  },
  subgroupModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  subgroupModalContainer: {
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
  },
  subgroupModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  subgroupModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  subgroupModalActions: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: 16,
    gap: 12,
  },
  subgroupModalContent: {
    flex: 1,
    paddingHorizontal: 16,
  },
  subgroupItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  subgroupItemInfo: {
    flex: 1,
    marginLeft: 12,
  },
  subgroupItemTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  subgroupItemDescription: {
    fontSize: 12,
    color: '#666',
  },
  subgroupModalFooter: {
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  subgroupModalButton: {
    borderRadius: 8,
  },

  // NOVO: Global Analysis
  globalAnalysisCard: {
    margin: 16,
    elevation: 3,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
  },
  globalAnalysisHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  globalAnalysisTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  globalAnalysisBadge: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  globalAnalysisStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
  },
  globalStatItem: {
    alignItems: 'center',
  },
  globalStatValue: {
    fontSize: 28,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  globalStatLabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },
  globalAnalysisDivider: {
    marginVertical: 16,
  },
  globalAnalysisSubtitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  globalConformityGrid: {
    flexDirection: 'row',
    gap: 16,
  },
  globalConformityItem: {
    flex: 1,
    padding: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    alignItems: 'center',
  },
  globalConformityHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  globalConformityIcon: {
    fontSize: 24,
  },
  globalConformityPercent: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
  },
  globalConformityLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginBottom: 4,
  },
  globalConformityCount: {
    fontSize: 12,
    color: '#999',
  },
  globalREStats: {
    backgroundColor: '#FFF8E1',
    padding: 12,
    borderRadius: 8,
    gap: 8,
  },
  globalREItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  globalRELabel: {
    fontSize: 14,
    color: '#666',
  },
  globalREValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#F57C00',
  },

  // MELHORADO: Visualização por Unidade com muito mais detalhes
  unitCard: {
    marginVertical: 8,
    elevation: 2,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
  },
  unitHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  unitInfo: {
    flex: 1,
  },
  unitCode: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
  },
  unitName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 4,
  },
  unitHierarchy: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },
  unitBadge: {
    backgroundColor: AVAQualisTheme.colors.primary,
    fontSize: 16,
    fontWeight: 'bold',
  },
  
  // NOVO: Estatísticas detalhadas da unidade
  unitDetailedStats: {
    padding: 16,
    backgroundColor: '#F0F7FF',
    borderRadius: 8,
    marginBottom: 16,
  },
  unitStatsTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1976D2',
    marginBottom: 12,
  },
  unitStatsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 16,
  },
  unitStatItem: {
    flex: 1,
    minWidth: '45%',
    alignItems: 'center',
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E3F2FD',
  },
  unitStatValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1976D2',
  },
  unitStatLabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },
  unitConformityDetails: {
    marginTop: 8,
    padding: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
  },
  unitConformityRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  unitConformityLabel: {
    fontSize: 14,
    color: '#666',
  },
  unitConformityValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unitRESection: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#FFF8E1',
    borderRadius: 6,
  },
  unitRESectionTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FF6F00',
    marginBottom: 8,
  },
  unitREGrid: {
    flexDirection: 'row',
    gap: 16,
  },
  unitREItem: {
    flex: 1,
    alignItems: 'center',
  },
  unitREValue: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#F57C00',
  },
  unitRELabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },
  
  // NOVO: Detalhes por avaliador na unidade
  unitEvaluatorSection: {
    marginBottom: 16,
  },
  unitEvaluatorTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  unitEvaluatorCard: {
    marginBottom: 12,
    padding: 12,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.secondary,
  },
  unitEvaluatorHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  unitEvaluatorInfo: {
    flex: 1,
  },
  unitEvaluatorName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unitEvaluatorEmail: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  unitEvaluatorChip: {
    marginTop: 4,
    alignSelf: 'flex-start',
  },
  unitEvaluatorStats: {
    alignItems: 'center',
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
  },
  unitEvaluatorStatValue: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  unitEvaluatorStatLabel: {
    fontSize: 10,
    color: '#666',
  },
  unitEvaluatorResults: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 8,
  },
  unitEvaluatorResultItem: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  unitEvaluatorResultIcon: {
    fontSize: 16,
  },
  unitEvaluatorResultText: {
    fontSize: 12,
    color: '#333',
  },
  unitEvaluatorAttachmentsButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 8,
    padding: 8,
    backgroundColor: '#E3F2FD',
    borderRadius: 4,
  },
  unitEvaluatorAttachmentsText: {
    fontSize: 12,
    color: '#1976D2',
    fontWeight: '600',
  },
  unitEvaluatorAttachmentsList: {
    marginTop: 8,
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
  },
  unitAttachmentItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 8,
    marginBottom: 6,
    backgroundColor: '#F8F9FA',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  unitAttachmentIcon: {
    width: 40,
    height: 40,
    borderRadius: 6,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  unitAttachmentEmoji: {
    fontSize: 20,
  },
  unitAttachmentContent: {
    flex: 1,
    paddingRight: 8,
  },
  unitAttachmentName: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  unitAttachmentFormTitle: {
    fontSize: 11,
    color: '#666',
    marginBottom: 1,
  },
  unitAttachmentRequirement: {
    fontSize: 11,
    color: '#666',
    marginBottom: 2,
  },
  unitAttachmentDescription: {
    fontSize: 11,
    color: '#666',
    fontStyle: 'italic',
    marginTop: 2,
  },
  unitAttachmentValidity: {
    fontSize: 10,
    color: '#FF9800',
    fontWeight: '600',
    marginTop: 2,
  },
  
  // Formulários da unidade
  unitFormsList: {
    gap: 8,
  },
  unitFormsTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  unitFormItem: {
    padding: 12,
    backgroundColor: '#F8F9FA',
    borderRadius: 6,
  },
  unitFormHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  unitFormTitleContainer: {
    flex: 1,
    paddingRight: 8,
  },
  unitFormTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unitFormDescription: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  unitFormDetails: {
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  unitFormStatsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 12,
  },
  unitFormStatItem: {
    flex: 1,
    minWidth: '45%',
  },
  unitFormStatLabel: {
    fontSize: 11,
    color: '#666',
  },
  unitFormStatValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unitFormEvaluators: {
    marginTop: 8,
    padding: 8,
    backgroundColor: '#E8F5E9',
    borderRadius: 4,
  },
  unitFormEvaluatorsTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#2E7D32',
    marginBottom: 4,
  },
  unitFormEvaluatorName: {
    fontSize: 12,
    color: '#333',
    marginBottom: 2,
  },
  unitFormDetailsButton: {
    marginTop: 8,
  },
  unitFormRequirements: {
    marginTop: 12,
    gap: 8,
  },

  // MELHORADO: Visualização por Requisito
  requirementCard: {
    marginVertical: 8,
    elevation: 2,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
  },
  requirementHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  requirementInfo: {
    flex: 1,
  },
  requirementCodeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  requirementText: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },
  requirementStats: {
    alignItems: 'flex-end',
    gap: 8,
  },
  occurrencesText: {
    fontSize: 12,
    color: '#666',
  },
  conformityChip: {
    backgroundColor: '#FFC107',
  },
  conformityChipGood: {
    backgroundColor: '#4CAF50',
  },
  conformityChipBad: {
    backgroundColor: '#F44336',
  },
  aggregateStats: {
    padding: 12,
    backgroundColor: '#E8F5E9',
    borderRadius: 6,
    marginBottom: 12,
  },
  aggregateStatsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2E7D32',
    marginBottom: 8,
  },
  statsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
  },
  statText: {
    fontSize: 12,
    color: '#333',
  },
  requirementFullDetails: {
    marginBottom: 12,
    gap: 12,
  },
  
  // NOVO: Resumo por avaliador no requisito
  requirementEvaluatorSection: {
    marginBottom: 12,
    padding: 12,
    backgroundColor: '#F0F7FF',
    borderRadius: 6,
  },
  requirementEvaluatorTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1976D2',
    marginBottom: 8,
  },
  requirementEvaluatorCard: {
    marginBottom: 8,
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderLeftWidth: 3,
    borderLeftColor: '#2196F3',
  },
  requirementEvaluatorHeader: {
    marginBottom: 6,
  },
  requirementEvaluatorName: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
  },
  requirementEvaluatorEmail: {
    fontSize: 11,
    color: '#666',
  },
  requirementEvaluatorResponse: {
    marginTop: 6,
    paddingTop: 6,
    borderTopWidth: 1,
    borderTopColor: '#E3F2FD',
  },
  requirementEvaluatorFormTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#1976D2',
  },
  requirementEvaluatorUnit: {
    fontSize: 11,
    color: '#666',
  },
  requirementEvaluatorAnswer: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
    marginTop: 2,
  },
  requirementEvaluatorFinding: {
    fontSize: 11,
    color: '#666',
    fontStyle: 'italic',
    marginTop: 2,
  },
  requirementEvaluatorAttachmentCount: {
    fontSize: 11,
    color: '#1976D2',
    fontWeight: '600',
    marginTop: 2,
  },
  
  // NOVO: Seção de anexos do requisito
  requirementAttachmentsSection: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#FFF8E1',
    borderRadius: 6,
  },
  requirementAttachmentsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#F57C00',
    marginBottom: 8,
  },
  requirementAttachmentItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 8,
    marginBottom: 6,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#FFE0B2',
  },
  requirementAttachmentIcon: {
    width: 40,
    height: 40,
    borderRadius: 6,
    backgroundColor: '#FFF3E0',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
  },
  requirementAttachmentEmoji: {
    fontSize: 20,
  },
  requirementAttachmentContent: {
    flex: 1,
    paddingRight: 8,
  },
  requirementAttachmentName: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  requirementAttachmentInfo: {
    fontSize: 11,
    color: '#666',
    marginBottom: 1,
  },
  requirementAttachmentUnit: {
    fontSize: 11,
    color: '#666',
  },
  requirementAttachmentDescription: {
    fontSize: 11,
    color: '#666',
    fontStyle: 'italic',
    marginTop: 2,
  },
  requirementAttachmentValidity: {
    fontSize: 10,
    color: '#FF9800',
    fontWeight: '600',
    marginTop: 2,
  },
  
  occurrencesList: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#F8F9FA',
    borderRadius: 6,
  },
  occurrencesTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginBottom: 8,
  },
  occurrenceItem: {
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  occurrenceFormTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginBottom: 4,
  },
  occurrenceUnit: {
    fontSize: 12,
    color: '#666',
    marginLeft: 12,
  },
  occurrenceEvaluators: {
    marginTop: 6,
    padding: 6,
    backgroundColor: '#E8F5E9',
    borderRadius: 4,
  },
  occurrenceEvaluatorLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: '#2E7D32',
    marginBottom: 2,
  },
  occurrenceEvaluatorName: {
    fontSize: 11,
    color: '#333',
    marginBottom: 1,
  },

  // Estado Vazio
  emptyCard: {
    marginVertical: 32,
    elevation: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
  },
  emptyContent: {
    alignItems: 'center',
    padding: 32,
  },
  emptyText: {
    marginTop: 16,
    fontSize: 16,
    color: '#999',
    textAlign: 'center',
  },

  // MELHORADO: Modal/Dialog com estilos de botões
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  dialogContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: 12,
    minWidth: 300,
    maxWidth: '90%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  dialogHeader: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
  },
  dialogTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  dialogContent: {
    paddingHorizontal: 24,
    paddingBottom: 20,
  },
  dialogMessage: {
    fontSize: 16,
    lineHeight: 24,
    color: AVAQualisTheme.colors.onSurface,
  },
  dialogActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 8,
  },
  dialogButton: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 8,
    minWidth: 80,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogButtonSecondary: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  dialogButtonPrimary: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  dialogButtonText: {
    fontSize: 14,
    fontWeight: '600',
  },
  dialogButtonTextSecondary: {
    color: AVAQualisTheme.colors.primary,
  },
  dialogButtonTextPrimary: {
    color: AVAQualisTheme.colors.onPrimary,
  },

  // ===== ESTILOS PARA FUNCIONALIDADES ADICIONAIS =====

  // Botões de ação do formulário
  formActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  editButton: {
    margin: -8,
  },
  deleteButton: {
    margin: -8,
  },

  // Seção de respostas não autorizadas
  unauthorizedSection: {
    marginTop: 16,
    padding: 12,
    backgroundColor: '#FFF3E0',
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#FF9800',
  },
  unauthorizedSectionTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#E65100',
    marginBottom: 8,
  },
  unauthorizedItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#FFE0B2',
  },
  unauthorizedItemInfo: {
    flex: 1,
  },
  unauthorizedItemName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unauthorizedItemLevel: {
    fontSize: 12,
    color: '#666',
  },
  unauthorizedItemActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  unauthorizedItemBadge: {
    backgroundColor: '#FF9800',
    fontSize: 10,
  },
  
  // Seção de respostas não autorizadas nos resultados consolidados
  unauthorizedResponsesSection: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#FFF3E0',
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#FF9800',
  },
  unauthorizedResponsesTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#E65100',
    marginBottom: 8,
  },
  unauthorizedResponseItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 4,
  },
  unauthorizedResponseName: {
    fontSize: 12,
    color: '#333',
    flex: 1,
  },
  unauthorizedResponseAnswer: {
    fontSize: 12,
    fontWeight: '600',
    marginHorizontal: 8,
  },

  // Modal para respostas não autorizadas
  unauthorizedModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  unauthorizedModalContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    maxWidth: '95%',
    maxHeight: '90%',
    width: 400,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  unauthorizedModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  unauthorizedModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    flex: 1,
  },
  unauthorizedModalContent: {
    flex: 1,
    padding: 20,
  },
  unauthorizedModalFooter: {
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  unauthorizedModalCloseButton: {
    borderRadius: 8,
  },

  // Cards de informações do avaliador não autorizado
  unauthorizedEvaluatorCard: {
    marginBottom: 16,
    elevation: 2,
  },
  unauthorizedEvaluatorName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
  },
  unauthorizedEvaluatorInfo: {
    fontSize: 14,
    color: '#666',
    marginBottom: 4,
  },
  unauthorizedBadge: {
    backgroundColor: '#FF9800',
    marginTop: 8,
    alignSelf: 'flex-start',
  },

  // Estatísticas do avaliador não autorizado
  unauthorizedStatsCard: {
    marginBottom: 16,
    elevation: 2,
  },
  unauthorizedStatsTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 12,
  },
  unauthorizedStatsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  unauthorizedStatItem: {
    alignItems: 'center',
  },
  unauthorizedStatValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  unauthorizedStatLabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 4,
  },

  // Respostas detalhadas do avaliador não autorizado
  unauthorizedResponsesCard: {
    elevation: 2,
  },
  unauthorizedResponsesTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 16,
  },
  unauthorizedResponseItem: {
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  unauthorizedResponseHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  unauthorizedResponseQuestion: {
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
    marginBottom: 8,
  },
  unauthorizedResponseAnswer: {
    marginBottom: 8,
  },
  unauthorizedResponseAnswerLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  unauthorizedResponseFinding: {
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  unauthorizedResponseFindingLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: '#666',
    marginBottom: 4,
  },
  unauthorizedResponseFindingText: {
    fontSize: 14,
    color: '#333',
    lineHeight: 18,
  },
  
  // NOVO: Anexos do avaliador não autorizado
  unauthorizedResponseAttachments: {
    marginTop: 8,
    padding: 8,
    backgroundColor: '#F0F7FF',
    borderRadius: 4,
  },
  unauthorizedResponseAttachmentsLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: '#1976D2',
    marginBottom: 6,
  },
  unauthorizedAttachmentItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginBottom: 4,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E3F2FD',
  },
  unauthorizedAttachmentIcon: {
    fontSize: 16,
    marginRight: 8,
  },
  unauthorizedAttachmentInfo: {
    flex: 1,
  },
  unauthorizedAttachmentName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
  },
  unauthorizedAttachmentDescription: {
    fontSize: 11,
    color: '#666',
    fontStyle: 'italic',
  },
  unauthorizedAttachmentValidity: {
    fontSize: 10,
    color: '#FF9800',
    fontWeight: '600',
    marginTop: 2,
  },

  // Aviso de respostas não autorizadas
  unauthorizedWarning: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF8E1',
    padding: 12,
    borderRadius: 8,
    marginBottom: 16,
    gap: 8,
  },
  unauthorizedWarningText: {
    flex: 1,
    fontSize: 13,
    color: '#F57C00',
    lineHeight: 18,
  },

  // Botões de deletar respostas
  deleteResponseButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    borderRadius: 12,
  },
  deleteAdditionalButton: {
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    borderRadius: 12,
  },
  additionalEvaluatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 4,
  },

  // Botão de backup
  backupButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: AVAQualisTheme.colors.primary,
    marginHorizontal: 16,
    marginVertical: 8,
    padding: 12,
    borderRadius: 8,
    elevation: 2,
    gap: 8,
  },
  backupButtonText: {
    flex: 1,
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },

  // MELHORADO: Modal de confirmação de exclusão completa
deleteModalContainer: {
  backgroundColor: '#FFFFFF',
  borderRadius: 16,
  maxWidth: 400,
  width: '90%',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 10 },
  shadowOpacity: 0.3,
  shadowRadius: 20,
  elevation: 20,  // AUMENTADO de 10 para 20
  zIndex: 1000,   // ADICIONADO
},
  deleteModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
  },
  deleteModalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#D32F2F',
    flex: 1,
  },
  deleteModalCloseButton: {
    margin: -8,
  },
  deleteModalContent: {
    paddingHorizontal: 24,
    paddingBottom: 24,
  },
  deleteModalWarningBox: {
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#FFEBEE',
    borderRadius: 12,
    marginBottom: 16,
  },
  deleteModalWarningText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#D32F2F',
    marginTop: 8,
    textAlign: 'center',
  },
  deleteModalMessage: {
    fontSize: 16,
    color: '#333',
    lineHeight: 24,
    marginBottom: 16,
  },
  deleteModalList: {
    marginBottom: 16,
  },
  deleteModalListItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    gap: 12,
  },
  deleteModalListText: {
    fontSize: 14,
    color: '#333',
    flex: 1,
  },
  deleteModalFinalWarning: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#D32F2F',
    textAlign: 'center',
    marginTop: 16,
    padding: 12,
    backgroundColor: '#FFEBEE',
    borderRadius: 8,
  },
  deleteModalActions: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  deleteModalButtonCancel: {
    flex: 1,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderRightWidth: 1,
    borderRightColor: '#E0E0E0',
  },
  deleteModalButtonCancelText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#666',
  },
  deleteModalButtonConfirm: {
    flex: 1,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#D32F2F',
    borderBottomRightRadius: 16,
  },
  deleteModalButtonConfirmText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },

  // MELHORADO: Modal de opções de exclusão
  deleteOptionsContainer: {
  backgroundColor: '#FFFFFF',
  borderRadius: 16,
  maxWidth: 500,
  width: '95%',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 10 },
  shadowOpacity: 0.3,
  shadowRadius: 20,
  elevation: 10,
  zIndex: 999,    // ADICIONADO
},
  deleteOptionsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  deleteOptionsTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  deleteOptionsCloseButton: {
    margin: -8,
  },
  deleteOptionsContent: {
    flex: 1,
    paddingHorizontal: 24,
    paddingTop: 16,
  },
  deleteOptionsSubtitle: {
    fontSize: 16,
    color: '#666',
    marginBottom: 16,
    lineHeight: 24,
  },
  deleteOptionCard: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  deleteOptionIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    elevation: 2,
  },
  deleteOptionContent: {
    flex: 1,
  },
  deleteOptionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 4,
  },
  deleteOptionDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
  deleteOptionEmail: {
    fontSize: 12,
    color: '#999',
    marginTop: 4,
  },
  deleteOptionsDivider: {
    marginVertical: 16,
    backgroundColor: '#E0E0E0',
  },
  deleteOptionsSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  noEvaluatorsContainer: {
    alignItems: 'center',
    padding: 32,
  },
  noEvaluatorsText: {
    fontSize: 14,
    color: '#999',
    textAlign: 'center',
    fontStyle: 'italic',
    marginTop: 8,
  },
  deleteOptionsFooter: {
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  deleteOptionsButtonCancel: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    alignItems: 'center',
  },
  deleteOptionsButtonCancelText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#666',
  },

  // Loading overlay para operações
  loadingOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingModal: {
    backgroundColor: '#FFFFFF',
    padding: 24,
    borderRadius: 12,
    alignItems: 'center',
    minWidth: 200,
    elevation: 8,
  },
  loadingModalText: {
    marginTop: 16,
    fontSize: 16,
    color: '#333',
    fontWeight: '600',
  },

  // Estilos para resultados não respondidos
  noResponsesSection: {
    marginTop: 16,
    padding: 12,
    backgroundColor: '#FAFAFA',
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#9E9E9E',
  },
  noResponsesTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#757575',
    marginBottom: 8,
  },
  noResponsesText: {
    fontSize: 13,
    color: '#757575',
    fontStyle: 'italic',
  },

  // Estilos adicionais para seções de avaliadores
  additionalEvaluatorsSection: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#FFF3E0',
    borderRadius: 6,
  },
// Estilos para Badge de Validação
  validationBadgeContainer: {
    marginTop: 12,
    padding: 12,
    backgroundColor: '#E8F5E9',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#4CAF50',
  },
  validationBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  validationBadgeText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2E7D32',
    marginLeft: 4,
  },
  validationInfo: {
    fontSize: 12,
    color: '#2E7D32',
    marginLeft: 24,
  },
  validationDate: {
    fontSize: 12,
    color: '#2E7D32',
    marginLeft: 24,
  },
});